import { ENDCAP_GRID_TYPE } from '@/features/shared/constants/productGridTypes'
import { type Grid } from '@/features/shop/components/ProductGrid/types'
import { type EndcapBySlotPos } from '@/features/shop/services/Search/types'

// If the endcap is hanging off of the edge of the grid then we move it on to the next row
const calculateEndcapPlacement = (
  requestedSlotPosition: number,
  slotSize: number,
  gridColumns: number,
): number => {
  const endingSlotPosition = requestedSlotPosition + (slotSize - 1)
  const fitsInRow = endingSlotPosition % gridColumns === 0
  return fitsInRow ? endingSlotPosition : endingSlotPosition - (slotSize - 1)
}

export const placeEndcapOnGrid = (
  currentGrid: Grid,
  gridColumns: number,
  index: number,
  endcapsBySlotPos: EndcapBySlotPos,
): Grid => {
  const grid: Grid = [...currentGrid]
  // Place endcap by slot position
  const endcapForIndex = endcapsBySlotPos[index]
  if (!endcapForIndex) return grid

  const placementIndex = calculateEndcapPlacement(
    endcapForIndex.slot_position,
    endcapForIndex.slot_size,
    gridColumns,
  )
  if (grid[placementIndex]) {
    // if there is already an object at this position we must splice our object in there
    grid.splice(placementIndex, 0, {
      renderType: ENDCAP_GRID_TYPE,
      data: endcapForIndex,
    })
  } else {
    // else we can just place the object in its position
    grid[placementIndex] = {
      renderType: ENDCAP_GRID_TYPE,
      data: endcapForIndex,
    }
  }

  return grid
}
